module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"filteredField":{"hint1":"Часть данных в этом поле скрыта, но будет применено оригинальное значение.","hint2":"Вы можете отредактировать."}},"en":{"filteredField":{"hint1":"Some of the data in this field is hidden. The original value will be applied.","hint2":"You can edit this field."}}}')
  delete Component.options._Ctor
}
